/**
 * What the header's three-dot menu offers a consumer: the free planning session once they've paid to self-fund, and the
 * "Planned Summary" shortcut to Your Plan once they've finished (see `useYourPlanShortcut`). Advisors get neither.
 */
import { useSelector } from 'react-redux';
import { selectSession } from '@/model';
import { useIsConsumerSession } from '@/hooks/use-app-mode';
import { useYourPlanShortcut } from './use-your-plan-shortcut';

export function useConsumerHeaderMenu(clientId: string | null | undefined) {
  const isConsumerSession = useIsConsumerSession();
  const hasPaid = useSelector(selectSession).clientStripe?.hasActivePlan ?? false;
  const yourPlan = useYourPlanShortcut(clientId);

  return {
    showPlanningSession: isConsumerSession && hasPaid,
    yourPlanTarget: yourPlan.isVisible ? yourPlan.target : null,
  };
}
